import { EffectHandler } from "../types/editor"

const MuteHanlder: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        editor.addEffectHtml({
            range: selection.caret,
            effectType: 'mute',
            effectValue: value,
            effectRender: () => { },
            isPlaceHolder: true
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default MuteHanlder